import {
  faAngleLeft,
  faAngleRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Pagination({
  page,
  setPage,
  totalPages,
  totalItems,
  pageSize,
}) {
  if (totalPages <= 1) return null;

  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalItems);

  return (
    <div className="mt-16 flex flex-col items-center gap-4 md:flex-row md:justify-between px-0 md:px-8">

      {/* Showing Results */}
      <p className="text-sm tracking-wide">
        Showing{" "}
        <span className="font-semibold">
          {start}-{end}
        </span>{" "}
        of{" "}
        <span className="font-semibold">
          {totalItems}
        </span>{" "}
        properties
      </p>

      {/* Controls */}
      <div className="flex items-center gap-6">

        <button
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
          className="flex items-center gap-2 border border-black px-5 py-4 text-xs uppercase tracking-[0.35em] text-black transition-all duration-300 hover:bg-black hover:text-white"
        >
          <FontAwesomeIcon icon={faAngleLeft} />
          Previous
        </button>

        <span className="text-sm uppercase tracking-[0.2em] text-cottage-primary text-center">
          Page {page} of {totalPages}
        </span>

        <button
          disabled={page === totalPages}
          onClick={() => setPage(page + 1)}
          className="flex items-center gap-2 border border-black px-5 py-4 text-xs uppercase tracking-[0.35em] text-black transition-all duration-300 hover:bg-black hover:text-white"
        >
          Next
          <FontAwesomeIcon icon={faAngleRight} />
        </button>

      </div>
    </div>
  );
}